// Generated from SVG to Code Figma Plugin

export const BaseFillPlay = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="black"
      fillOpacity="0.64"
      data-figma-bg-blur-radius="10.5"
    />
    <path
      d="M9.65625 12V7.75L13.3369 9.875L17.0175 12L13.3369 14.125L9.65625 16.25V12Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.8403"
    />
    <defs>
      <clipPath id="bgblur_0_4586_1810_clip_path" transform="translate(10.5 10.5)">
        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" />
      </clipPath>
    </defs>
  </svg>
);
